import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
    const [animationStage, setAnimationStage] = useState(0);

    useEffect(() => {
        // Stage 1: Start the 3D flip (300ms)
        const timer1 = setTimeout(() => setAnimationStage(1), 300);
        // Stage 2: Text starts hiding (800ms)
        const timer2 = setTimeout(() => setAnimationStage(2), 800);
        // Stage 3: Only logo visible (1500ms)
        const timer3 = setTimeout(() => setAnimationStage(3), 1500);
        // Stage 4: Fade out (2800ms)
        const timer4 = setTimeout(() => setAnimationStage(4), 2800);
        // Complete (3300ms)
        const timer5 = setTimeout(() => onComplete(), 3300);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
            clearTimeout(timer3);
            clearTimeout(timer4);
            clearTimeout(timer5);
        };
    }, [onComplete]);

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-500"
            style={{
                backgroundColor: '#2e0510',
                opacity: animationStage >= 4 ? 0 : 1,
                pointerEvents: animationStage >= 4 ? 'none' : 'auto',
                perspective: '1000px' // Enable 3D perspective
            }}
        >
            <div
                className="relative flex items-center justify-center"
                style={{
                    transformStyle: 'preserve-3d'
                }}
            >
                {/* Logo Container - 3D flip on Y axis - starts mid-spin */}
                <div
                    className="relative z-20"
                    style={{
                        transform: animationStage >= 1
                            ? 'rotateY(360deg) scale(1.1)'
                            : 'rotateY(180deg) scale(1)',
                        transition: 'transform 1s ease-in-out',
                        transformStyle: 'preserve-3d'
                    }}
                >
                    {/* Glow Effect */}
                    <div
                        className="absolute inset-0 rounded-full blur-2xl"
                        style={{
                            background: 'radial-gradient(circle, rgba(231, 78, 74, 0.5) 0%, transparent 70%)',
                            transform: 'scale(2) translateZ(-10px)',
                            opacity: animationStage >= 3 ? 1 : 0.5,
                            transition: 'opacity 0.5s ease'
                        }}
                    />

                    {/* Logo Image - rotates with container */}
                    <img
                        src="/radchat-logo.png"
                        alt="RadChat"
                        className="relative z-10"
                        style={{
                            width: '100px',
                            height: 'auto',
                            filter: animationStage >= 3
                                ? 'drop-shadow(0 0 30px rgba(231, 78, 74, 0.8))'
                                : 'drop-shadow(0 0 15px rgba(231, 78, 74, 0.4))',
                            transition: 'filter 0.5s ease'
                        }}
                    />
                </div>

                {/* RadChat Text - absolutely positioned to the right of logo, slides behind and hides */}
                <div
                    className="absolute flex items-center overflow-hidden"
                    style={{
                        left: '110px',
                        transform: animationStage >= 2
                            ? 'translateX(-80px) scale(0.8)'
                            : 'translateX(0) scale(1)',
                        opacity: animationStage >= 2 ? 0 : 1,
                        transition: 'all 0.6s ease-in-out',
                        zIndex: 10
                    }}
                >
                    <span
                        className="text-4xl font-bold tracking-tight whitespace-nowrap"
                        style={{
                            fontFamily: 'Space Grotesk, sans-serif',
                            color: '#e74e4a',
                            textShadow: '0 0 15px rgba(231, 78, 74, 0.4)'
                        }}
                    >
                        Rad
                    </span>
                    <span
                        className="text-4xl font-bold tracking-tight whitespace-nowrap"
                        style={{
                            fontFamily: 'Space Grotesk, sans-serif',
                            color: '#e74e4a',
                            textShadow: '0 0 15px rgba(231, 78, 74, 0.4)'
                        }}
                    >
                        Chat
                    </span>
                </div>
            </div>

            {/* Tagline - appears when only logo is visible */}
            <p
                className="absolute bottom-1/3 text-lg transition-all duration-700"
                style={{
                    color: '#F5E3D7',
                    opacity: animationStage >= 3 ? 0.7 : 0,
                    transform: animationStage >= 3 ? 'translateY(0)' : 'translateY(20px)',
                }}
            >
                Connect. Chat. Create.
            </p>
        </div>
    );
};

export default SplashScreen;
